import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/workPlanRest/listAll',
    method: 'post',
    data,
  })
}

export function doAdd(data) {
  return request({
    url: '/api/workPlanRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/workPlanRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/workPlanRest/' + data,
    method: 'delete',
  })
}
